import React from "react";
import {
  IconBrandFacebook,
  IconBrandX,
  IconBrandLinkedin,
} from "@tabler/icons-react";
import classes from "../../css/Footer.module.css";
import { Link } from "react-router-dom";
import { Text } from "../Generics/Text";
import { useAppColors } from "@/hooks/contextHooks/useAppColors";

export const Footer: React.FC = () => {
  const { colors } = useAppColors();
  return (
    <div className={classes.footer} style={{ backgroundColor: colors.brand }}>
      <div className={classes.leftSection}>
        <a href="https://www.facebook.com/D.ICE.Engineering" target="_blank">
          <IconBrandFacebook size={24} stroke={1.5} color="white" />
        </a>
        <a href="https://x.com/D_ICE_eng" target="_blank">
          <IconBrandX size={24} stroke={1.5} color="white" />
        </a>
        <a
          href="https://www.linkedin.com/company/d-ice-engineering/"
          target="_blank"
        >
          <IconBrandLinkedin size={24} stroke={1.5} color="white" />
        </a>
      </div>
      <div className={classes.centerSection}>
        <img
          src={
            "https://s3.us-east-1.amazonaws.com/d-ice.fr/assets/dice-logo-white.png"
          }
          alt="Logo"
          className={classes.logo}
        />
        <div className={classes.slogan}>
          <Text color="white">Real Challenges. True Solutions</Text>
        </div>
      </div>
      <div className={classes.rightSection}>
        <Link // component={Link}
          to="/contact"
          className={classes.link}
        >
          Contact
        </Link>
        <Link
          // component={Link}
          to="/terms"
          className={classes.link}
        >
          Terms of use
        </Link>
      </div>
    </div>
  );
};
